export const BIV1 = [
  "propertiesCompletedWithinLast36Months",
  "foreignNational",
  "ImmigrationStatus",
  "originalCreditScore",
  "InState",
];

export const quickLoanBIV1 = [
  "borrowerType",
  "entityType",
  "citizenshipStatus",
  "creditScoreActual",
  // "borrowingEntityName",
  // "borrowerEmail",
  // "borrowerName",
  // "guarantorName",
  // "guarantorEmail",
];

export const detailedLoanBIV1 = [
  "borrowerType",
  "creditScoreActual",
  "citizenshipStatus",
  "FirstTimeHomeBuyer"
];

export const detailedLoanBIV2 = [
  "borrowerType",
  "entityType",
  "creditScoreActual",
  "citizenshipStatus",
  // "borrowingEntityName",
  // "borrowerName",
  // "borrowerEmail",
  // "guarantorName",
  // "guarantorEmail",
  "FirstTimeHomeBuyer",
];